import { Injectable, Component, Inject, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Location } from '@angular/common';
import {Router} from '@angular/router';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Title} from '@angular/platform-browser';
import {EMPTY, from, interval, of} from 'rxjs';
import {catchError, concatMap, mergeMap, takeWhile, finalize, tap, expand} from 'rxjs/operators';
import {ApiService} from '../shared/api.service';
import {Assignment} from '../assignments/assignment.model';
import {AssignmentsService} from '../shared/assignments.service';
import {ImagesService, ImagesErrorhDialog} from '../shared/images.service';
import {Slide} from './slide/slide.model';
import {NotificationService} from '../shared/notification.service';
import {UserService} from '../shared/user.service';
import { NotInTeam } from '../fields/team.component';
import { Site } from '../shared/site.model';
import {Utils} from '../utils';
import { SImage } from '../shared/image.model';
    
@Injectable()
export class SlideshowService {
    assignment;
    autosave;
    backup;
    slideIndex = 0;
    slides = [];
    title = '';
    tags = [];
    locked = true;
    publishError = '';
    quiz = false;
    summary = false;
    rsoc = false;
    tiers = [];
    slidesLoaded = new EventEmitter();
    saving = false;
    publishing = false;
    publishComplete = new EventEmitter();
    publishCompleteSubscription;
    retrying = false;
    retryCounter = 5;
    showRetryMessage = false;
    retry = new EventEmitter();
    retrySubscription;
    retryApiSubscription;
    lockCheckOpen = false;
    _locked = new EventEmitter();
    autosaving = false;
    _autosaveChecked = false;
    autosaveChecked = new EventEmitter();
    autosaveOpen = false;
    lastModified;
    heartbeatSubscription;
    slidesComplete = new EventEmitter();
    slidesCompleteSubscription;
    assignmentComplete = new EventEmitter();
    assignmentCompleteSubscription;
    sending = false;
    warning = false;
    whosEditingSubscription;
    featuredImageChange = new EventEmitter();
    resultsChanged = new EventEmitter();
    reload = false;
    clones = [];
    answerSummaryPlaceholder = 'Correct Answer Summary';
    messages = [];
    commentAdded = new EventEmitter();
    assignmentLoaded = new EventEmitter();
    _assignmentLoaded = false;
    targetPublishDateChange = new EventEmitter();
    statusChange = new EventEmitter();
    slideBlacklisted = new EventEmitter();
    writingTabError = false;
    metaTabError = false;
    msnFields;
    adsTabError = false;
    taxonomyOptions;
    paTaxonomyOptions;
    currentTabIndex = 0;
    slideOrderChange = new EventEmitter();
    slideContentChange = new EventEmitter();
    mlData = {
        prompt: '',
    };

    constructor(
        private api: ApiService,
        private assignmentService: AssignmentsService,
        public dialog: MatDialog,
        private images: ImagesService,
        private location: Location,
        private notifyService: NotificationService,
        private router: Router,
        private titleService: Title,
        private userService: UserService,
        private utils: Utils
    ) {
        this.slidesLoaded.subscribe(slideIndex => {
            this.backupLocally();
            this.whosEditing();
            this.setSEOData();
            this.getImages();
            this.checkBlacklist();
            this.setupAds();
            this.checkAdHeadlineBlackList();
        });
    }
    initSlides() {
        if(this.assignment.quizType == 'personality') {
            this.createSlide(); // create first slide
            if( this.assignment.outro ) { // create outro slide too
                this.createSlide();
            }

            return;
        }
        
        if (this.assignment.slideCount >= this.slides.length) {
            this.createMultipleSlides(0, this.assignment.slideCount + (this.assignment.outro ? 2 : 1));

            return;
        }
    }
    getClones() {
        this.api.doAction('post', 'clone', {
            action: 'get',
            data: this.assignment.clones
        }).subscribe(
            data => {
                this.clones = data;
            }
        );
    }
    getImages() {
        this.images.loadImages(this.assignment, this.slides);
    }
    getFeaturedImage() {
        const slideImages = this.slides[0].images;
        if( slideImages.length == 0 ) {
            return false;
        }
        const allImages = this.images.images;
        for(var i = 0; i < allImages.length; i++) {
            if( allImages[i].id == slideImages[0].id ) {
                return allImages[i];
            }
        }
        return false;
    }
    isFeaturedImage(img) {
        const images = this.slides[0].images;
        if( images.length == 0 ) {
            return false;
        }
        return images[0].id == img.id;
    }
    toggleFeaturedImage(img) {
        if( this.locked ) {
            return;
        }
        if( this.images.isMobileOnlyImage(img) ) {
            this.dialog.open(FeaturedImageDialog);
            return;
        }
        let images = this.slides[0].images;
        if( images.length == 0 || images[0].id != img.id ) {
            this.assignment.featured_media = img.id;
            this.slides[0].images = [img];
            this.featuredImageChange.emit(img);
            return;
        }
        if( images[0].id == img.id ) {
            this.assignment.featured_media = 0;
            this.slides[0].images = [];
            this.featuredImageChange.emit();
        }
    }
    getSlideNumber(slide, i) {
        let num = i;
        if( slide.intro ) {
            num = 'in';
        }
        if( this.quiz && slide.outro ) {
            num = 'r';
        }
        if( !this.assignment.intro ) {
            return num + 1;
        }
        return num;
    }
    removeAllTeasers() {
        this.slides.forEach((slide, i) => {
            this.slides[i].teaser = '';
            this.slides[i].teaseToSlide = '';
        });
        this.slidesLoaded.emit(this.slideIndex);
    }
    setSEOData() {
        if( !this.assignment ) {
            return;
        }
        if( this.assignment.metaDescription == '' ) {
            this.assignment.metaDescription = this.cleanContent(this.slides[0].metaDescription);
        }
        if( this.assignment.metaTitle == '' ) {
            this.assignment.metaTitle = this.cleanContent(this.assignment.articleTitle);
        }
    }
    whosEditing() {
        this.whosEditingSubscription = this.api.heartbeat
            .pipe(
                takeWhile(val => this.assignment !== null),
                finalize(() => {
                    this.whosEditingSubscription.unsubscribe();
                })
            ).subscribe(
                data => {
                    if( this.locked ) {
                        this.api.doAction('post', 'meta', {
                            action: 'get',
                            id: this.assignment.id,
                            fields: [
                                {
                                    name: 'lock'
                                }
                            ]
                        }).pipe(takeWhile(val => this.assignment !== null)).subscribe(
                            data => {
                                const lock = data.shift() || {value: null};
                                this.assignment.lock = lock.value;
                            }
                        );
                    }
                }
            );
    }
    cloneMe(me) {
        return JSON.parse(JSON.stringify(me));
    }
    getBackup({slides, assignment}) {
        let a = this.cloneMe(assignment);
        delete a.lock;
        let s = this.cloneMe(slides);
        return {
            assignment: a,
            slides: s
        };
    }
    backupLocally() {
        if( this.locked || this.api.getProp('loggedOut') || !this.assignment ) {
            return;
        }
        this.autosave = this.getBackup(this);
        this.backup = this.getBackup(this);
    }
    objEq(o, n) {
        return JSON.stringify([o]) === JSON.stringify([n]);
    }
    maybeAutosave() {
        if( this.locked || this.saving || this.api.getProp('loggedOut') || !this.assignment || this.autosaving ) {
            return;
        }
        let user = this.api.getProp('currentUserId');
        let current = this.getBackup(this);
        let autosave = this.autosave;
        if( !this.objEq(autosave, current) ) {
            this.autosaving = true;
            let posts = [current.assignment].concat(current.slides)
            this.api.doAction('post', 'autosave', {
                    id: current.assignment.id,
                    posts: posts,
                    user: user,
                    published: current.assignment.published, // TODO: why do we need this?
                    action: 'update'
                }).pipe(
                    finalize(() => {
                        this.autosaving = false;
                    }
                )).subscribe(
                    data => {
                        this.autosaving = false;
                        this.autosave = current;
                    }
                );
        }
    }
    titleChange(slide) {
        this.warning = false;
        let title = slide.title || '';
        if( slide.intro ) {
            title = this.assignment.articleTitle;
        } else {
            slide.headers[0] = slide.title;
        }
        const cleanTitle = this.cleanContent(title);
        slide.metaTitle = cleanTitle.substring(0, 70);
        this.checkSlideBlacklist(slide);
    }
    cleanContent(content) {
        content = content.replace(/<([abipsu]|sup|sub)[^>]*>|<\/([abipsu]|sup|sub)>/g, '');
        return content;
    }
    testDiv;
    contentChange(html, slide, field) {
        let content = [];
        let desc = '';
        let div = this.testDiv;
        if( !div ) {
            div = document.createElement('div');
            this.testDiv = div;
        }
        div.innerHTML = html;
        const tags = div.childNodes;
        for(var i = 0; i < tags.length; i++) {
            let p = tags[i] as Element;
            let inner = p.innerHTML;
            if( p.nodeType == 3 ) {
                inner = p.textContent;
            }
            desc += p.textContent + ' ';
            if( inner.trim() !== '' ) {
                content.push({
                    text: inner
                });
            }
        }
        if( tags.length == 0 && html ) {
            content.push({
                text: html
            });
            desc = html;
        }
        if(field === 'content') {
            slide.content = content;
            this.updateMetaDescription(slide, desc);
        } else if(field === 'summary') {
            slide.summary = content;
        }
        this.checkSlideBlacklist(slide);
        div.innerHTML = '';
        this.slideContentChange.emit(slide);
    }
    updateMetaDescription(slide: Slide, text: string) {
        slide.metaDescription = text.substr(0, 160);
    }
    calculateTiers() {
        let tiers = [];
        let slideCount = this.slides.length;
        if( slideCount < 3 ) {
            return;
        }
        let questionCount = slideCount - 2;
        let resultCount = this.slides[slideCount - 1].content.length;
        let prev = 0;
        for(var i = 0; i < resultCount; i++) {
            let resultNum = (i + 1) / resultCount;
            let total = Math.floor(questionCount * resultNum);
            if( i == (resultCount - 1)) {
                total = questionCount;
            }
            tiers.push({
                min: prev == 0 ? 0 : prev + 1,
                max: total
            });
            prev = total;
        }
        this.tiers = tiers;
    }
    resetSlideshow() {
        if( !this.locked ) {
            this.clearLock();
        }        
        this.assignment = null;
        this.autosave = null;
        this.slideIndex = 0;
        this.slides = [];
        this.tags = [];
        this.publishError = '';
        this.quiz = false;
        this.summary = false;
        this.rsoc = false;
        this.tiers = [];
        this.saving = false;
        this.publishing = false;
        this.lockCheckOpen = false;
        this.autosaving = false;
        this._autosaveChecked = false;
        this.lastModified = '';
        this.images.reset();
        this.taxonomyOptions = null;
        this.paTaxonomyOptions = null;
        this.destroyRetry();
        if( this.publishCompleteSubscription ) {
            this.publishCompleteSubscription.unsubscribe();
        }
        if( this.slidesCompleteSubscription ) {
            this.slidesCompleteSubscription.unsubscribe();
        }
        if( this.assignmentCompleteSubscription ) {
            this.assignmentCompleteSubscription.unsubscribe();
        }
    }
    stop() {
        if( this.heartbeatSubscription ) {
            this.heartbeatSubscription.unsubscribe();
        }
        if( this.whosEditingSubscription ) {
            this.whosEditingSubscription.unsubscribe();
        }
    }
    loadSlideshow(id) {
        if( this.reload ) {
            this.reload = false;
            return;
        }
        this.resetSlideshow();
        let assignment = this.assignmentService.getAssignment(id);
        if( assignment ) {
            this.setSlideshow(assignment);
        } else {
            this.api.doAction('post', 'assignments', {
                action: 'get',
                id: id
            }).subscribe(assignment => {
                assignment = new Assignment(assignment);
                (() => this.setSlideshow(assignment))();
            });
        }
        this.notifyService.filter([id]); 
    }
    setLock() {
        const subscription = this.assignmentService.assignmentLocked.subscribe(locked => {
            if( locked ) {
                this.locked = false;
                this._locked.emit(this.locked);
            }
            subscription.unsubscribe();
        });
        this.assignmentService.lock(this.assignment);
    }
    lockCheck() {
        if( this.api.getProp('loggedOut') || this.lockCheckOpen || this.locked || !this.assignment || this.saving || this.publishing )  return;
        
        this.api.doAction('post', 'meta', {
                action: 'get',
                id: this.assignment.id,
                fields: [
                    {
                        name: 'lock'
                    }
                ]
            })
            .pipe(
                takeWhile(val => this.assignment !== null)
            ).subscribe(
                data => {
                    const currentLock = data.shift() || {value: false};
                    let userId = this.api.getProp('currentUserId');
                    if( currentLock.value && currentLock.value.user != userId ) {
                        this.lockCheckOpen = true;
                        let dialog = this.dialog.open(TakeoverDialog, {
                            disableClose: true,
                            data: {
                                user: currentLock.value.name
                            }
                        });
                        dialog.afterClosed().subscribe(cancel => {
                            this.lockCheckOpen = false;
                            if( cancel ) {
                                this.locked = true;
                            } else {
                                this.locked = false;
                                this.assignmentService.lock(this.assignment);
                            }
                            this._locked.emit(this.locked);
                        });
                    } else if( currentLock.value && currentLock.value.user == userId && (currentLock.value.time + (1000 * 60 * 5)) < (new Date).getTime() ) {
                        this.assignmentService.lock(this.assignment);
                    }
                }
            );
    }
    deleteAutosave() {
        this.api.doAction('post', 'autosave', {
                id: this.assignment.id,
                user: this.api.getProp('currentUserId'),
                action: 'delete'
            })
            .pipe(
                takeWhile(val => this.assignment !== null)
            ).subscribe(
                data => {
                    console.log('Autosave deleted.', data);
                }
            );
    }
    getAutosave(assignment) {
        let user = this.api.getProp('currentUserId');
        let clones = assignment.clones;
        this.api.doAction('post', 'autosave', {
            id: assignment.id,
            user: user,
            date: this.lastModified,
            action: 'get'
        }).pipe(
            takeWhile(val => this.assignment !== null),
            finalize(() => {
                this.autosaveChecked.emit(true);
            })
        ).subscribe(
            data => {
                if( data.found && Array.isArray(data.posts) ) {
                    let posts = data.posts;
                    let current = this.getBackup(this);
                    let stored = this.getBackup({
                        assignment: posts.shift(),
                        slides: posts
                    });
                    if( !this.objEq(stored, current) ) {
                        this.autosaveOpen = true;
                        let dialog = this.dialog.open(AutosaveDialog, {
                            data: {
                                date: data.date
                            }
                        });
                        dialog.afterClosed().subscribe(cancel => {
                            this.autosaveOpen = false;
                            if( !cancel ) {
                                this.assignment = new Assignment(stored.assignment);
                                this.assignment.clones = clones;
                                this.slides = stored.slides.map(item => {
                                    return new Slide(item);
                                });
                                this.getImages();
                                this.getClones();
                            }
                        });
                    }
                }
            }
        );
    }
    start() {
        this.heartbeatSubscription = this.api.heartbeat
            .pipe(
                takeWhile(val => this.assignment !== null)
            ).subscribe(() => {
                this.lockCheck();
                this.maybeAutosave();
            });
    }
    grab(actionsEl) {
        // start heartbeat after autosave has been checked
        let autosaveSubscription = this.autosaveChecked.subscribe(checked => {
            this._autosaveChecked = true;
            this.start();
            this.assignment.metaTitle = this.cleanContent(this.assignment.metaTitle);
            this.assignment.metaDescription = this.cleanContent(this.assignment.metaDescription);
            autosaveSubscription.unsubscribe();
        });
        // get autosave after assignment is unlocked
        let lockSubscription = this._locked.subscribe(locked => {
            this.lastModified = this.assignment.modified_gmt;
            this.backupLocally();
            this.getAutosave(this.assignment);
            lockSubscription.unsubscribe();
        });
        this.setLock();
    }
    updateMessages() {
        const team = this.assignment.team;
        const blog_ids = this.assignment.sites.map(item => item.blog_id);
        const sites = this.api.getProp('sites');
        this.messages = [];
        for(var i = 0; i < team.length; i++) {
            const member = team[i];
            const member_blogs = member.limited;
            if( member_blogs && member_blogs.length > 0 ) {
                let memberNeedsBlog = true;
                for(var j = 0; j < blog_ids.length; j++) {
                    if( member_blogs.indexOf(blog_ids[j]) !== -1 ) {
                        memberNeedsBlog = false;
                        break;
                    }
                }
                if( memberNeedsBlog ) {
                    const domains = sites.filter(item => member_blogs.indexOf(item.blog_id) !== -1).map(item => item.domain);
                    this.messages.push(member.name + ' needs ' + domains.join(' or ') + ' for access to this assignment');
                }
            }
        }
    }
    userCanView(assignment) {
        const user = this.api.getProp('user');
        if( user.limited.length === 0 || assignment.author == user.id ) {
            return true;
        }
        const blog_ids = assignment.sites.map(item => item.blog_id);
        for( var i = 0; i < blog_ids.length; i++ ) {
            if( user.limited.indexOf(blog_ids[i]) !== -1 ) {
                return true;
            }
        }
        let author = this.userService.getUser(assignment.author);
        const dialogRef = this.dialog.open(CannotViewDialog, {
            data: author
        });
        dialogRef.afterClosed().subscribe(data => {
            this.router.navigate(['/assignments', 'queue']);
        });
        return false;
    }
    setTaxonomyOptions() {
        const taxonomyOptions = JSON.parse(JSON.stringify( this.api.getProp('taxonomies') ));
        const paTaxonomyOptions = JSON.parse(JSON.stringify( this.api.getProp('paTaxonomies') ));
        const assignmentTaxes = this.assignment.taxonomies;
        const slugs = Object.keys(assignmentTaxes);
        for(var i = 0; i < slugs.length; i++) {
            const slug = slugs[i];
            const terms = this.assignment.taxonomies[slug];
            if( !terms ) continue;
            const selected = terms.map(item => item.name.toLowerCase());
            if( taxonomyOptions[slug] ) {
                const options = taxonomyOptions[slug].options;
                for(var k = 0; k < options.length; k++) {
                    const option = options[k];
                    const name = option.name.toLowerCase();
                    if( selected.indexOf(name) !== -1 ) {
                        option.checked = true;
                    }
                }
            }
            if( paTaxonomyOptions[slug] ) {
                const paOptions = paTaxonomyOptions[slug].options;
                for(var j = 0; j < paOptions.length; j++) {
                    const paOption = paOptions[j];
                    const name = paOption.name.toLowerCase();
                    if( selected.indexOf(name) !== -1 ) {
                        paOption.checked = true;
                    }
                }
            }
        }
        paTaxonomyOptions.decade = taxonomyOptions.decade;
        this.taxonomyOptions = taxonomyOptions;
        this.paTaxonomyOptions = paTaxonomyOptions;
    }
    setSlideshow(assignment) {
        if( !this.userCanView(assignment) ) {
            return;
        }
        let quiz = assignment.childType == 'quiz' ? true : false;
        let summary = assignment.childType == 'summary' ? true : false;
        let rsoc = assignment.childType == 'rsoc' ? true : false;
        this.quiz = quiz;
        this.summary = summary;
        this.rsoc = rsoc;
        this.assignment = assignment;
        this._assignmentLoaded = true;
        this.assignmentLoaded.emit(this.assignment);
        this.getClones();
        this.updateMessages();
        this.setTaxonomyOptions();
        this.title = assignment.title;
        this.slides = [];
        if( assignment.slides ) {
            this.getSlides(this.assignment.slides);
        } else {
            this.initSlides();
            this.slidesLoaded.emit(this.slideIndex);
        }
        let title = 'Slideshow | ' + assignment.title;
        if( quiz ) {
            title = 'Quiz | ' + assignment.title;
            if( assignment.quizType === 'personality' ) {
                this.answerSummaryPlaceholder = 'Generalized Question Summary';
            }
        }
        this.titleService.setTitle('SWARM | ' + title);
    }
    getChunk(chunk, index) {
        return this.api.doAction('post', 'slides', {
            action: 'read',
            include: chunk,
            page: index + 1
        });
    }
    getChunks(chunks) {
        return from(chunks).pipe(
            concatMap( // performs all requests sequentially
                (chunk, index) => from(this.getChunk(chunk, index)).pipe(
                    catchError(error => of(error)) // allows error handling per request
                )
            )
        );
    }
    getSlides(slides) {
        if( !slides ) return;
        // chunk load slides, concatMap to preserve order
        let slideArr = [];
        slides += ''; // convert to string
        if( slides.indexOf(',') === -1 ) {
            slideArr = [slides];
        } else {
            slideArr = slides.split(',');
        }
        let len = slideArr.length;
        let chunks = [];
        let size = 20;
        for (let i = 0; i < len; i += size) {
            let chunk = slideArr.slice(i, i + size);
            chunks.push(chunk.join(','));
        }
        this.getChunks(chunks).pipe(
            takeWhile(val => this.assignment !== null),
            finalize(() => {
                this.slidesLoaded.emit(this.slideIndex);
                if( this.quiz ) {
                    this.calculateTiers();
                }
            })
        ).subscribe(
            (data) => {
                let slides = data.map(item => {
                    item = new Slide(item);
                    return item;
                });
                
                this.slides = this.slides.concat(slides);

            }
        );
    }
    setSlide(index, scroll = true) {
        this.slideIndex = index;
        if(scroll) {
            this.scroll(index);
        }
        this.updateLocation(index);
    }
    scroll(index) {
        if(index == 0) {
            window.scrollTo(0, 0);
            return;
        }

        let anchor = document.getElementById('slide-' + index);
        if( anchor ) {
            anchor.scrollIntoView();
        }
    }
    updateLocation(index) {
        if( !this.assignment ) return;
        let path = this.location.path();
        let prefix = '/slideshow/' + this.assignment.id + '/';
        let pathslide = path.replace(prefix, '');
        if( index != pathslide ) {
            this.location.replaceState(prefix + index);
        }
    }
    setSlideOrder() {
        let slidesIds = [];
        let intro = this.assignment.intro;
        let outro = this.assignment.outro;
        let last = this.slides.length - 1;
        this.slides.forEach((slide, index) => {
            slidesIds.push(slide.id);
            slide.intro = index == 0 ? intro : 0;
            slide.outro = ( index == last && last > 1 ) ? outro : 0;
        });
        this.assignment.slides = slidesIds.join(',');
        this.slideOrderChange.emit();
    }
    newSlide() {
        let slide = new Slide({});
        let slides = this.slides;
        let length = slides.length;
        let intro = this.assignment.intro;
        let outro = this.assignment.outro;
        let last = length - 1;
        slide.intro = length == 0 ? intro : 0; // if this is the first slide set the intro
        slide.outro = length == 1 ? outro : 0; // set outro if we need one
        if( outro && !slide.intro && !slide.outro ) { // insert before outro
            length = last;
        }
        this.slides.splice(length, 0, slide);
        if( this.quiz ) {
            this.calculateTiers()
        }
        this.titleChange(slide);
        this.setSlide(length, false);
        return {
            slide: slide,
            index: length
        };
    }
    relocate(index, slide) {
        let slides = this.slides;
        let assignment = this.assignment;
        let router = this.router;
        let prev = index - 1;
        let next = index + 1;
        let i = 0;
        if( slides.length == 0 ) {
            this.createSlide();
            return;
        }
        
        if( slides[prev] ) {
            i = prev;
        } else if( slides[next] ) {
            i = next;
        }
        
        router.navigate(['slideshow', assignment.id, i]);
    }
    removeSlide(index) {
        let slide = this.slides[index];
        if( !slide.id ) {
            this.slides.splice(index, 1);
            this.slides = [].concat(this.slides);
            if( this.quiz ) {
                this.calculateTiers()
            }
        } else {
            let dialogData = {
                title: 'Are you sure you wish to delete this slide?',
                messages: ['Slide ' + index + ': ' + slide.title]
            }
            let dialogRef = this.dialog.open(DeleteDialog, {
                data: dialogData
            });
            dialogRef.afterClosed().subscribe(returnData => {
                if( returnData === true ) {
                    this.api.doAction('post', 'slides', {
                        action: 'delete',
                        id: slide.id
                    }).subscribe(
                        data => {
                            // data = slide in case we want an undo option
                            this.slides.splice(index, 1);
                            this.slides = [].concat(this.slides);
                            let slideIds = this.slides.map(slide => slide.id);
                            this.assignment.slides = slideIds.join(',');
                            if( this.quiz ) {
                                this.calculateTiers()
                            }
                        }
                    );
                }
            });
        }
        if( index == this.slideIndex ) {
            this.relocate(index, slide);
        }
    }
    removeSlides(slideList) {
        const ids = [];
        slideList.forEach(slideIndex => {
            if(!this.slides[slideIndex]) return;
            if(this.assignment.childType == 'quiz' && this.slides[slideIndex].outro) return;
            ids.push(this.slides[slideIndex].id);
        });
        if(ids.length == 0) return;
        this.api.doAction('post', 'slides', {
            action: 'delete_multi',
            ids: ids
        }).subscribe(
            data => {
                ids.forEach(id => {
                    // data = slide in case we want an undo option
                    const index = this.slides.findIndex(slide => slide.id == id);
                    this.slides.splice(index, 1);
                    this.slides = [].concat(this.slides);
                    let slideIds = this.slides.map(slide => slide.id);
                    this.assignment.slides = slideIds.join(',');
                    if( this.quiz ) {
                        this.calculateTiers();
                    }
                });
            }
        );
    }
    updateSlideIds() {
        let slideIds = this.slides.map(slide => slide.id).join(',');
        this.api.doAction('post', 'meta', {
            id: this.assignment.id,
            action: 'update',
            fields: [
                {
                    name: 'slides',
                    value: slideIds
                }
            ]
        })
        .pipe(
            takeWhile(val => this.slides.length !== 0),
            finalize(() => {
                this.saving = false;
            })
        )
        .subscribe();
    }
    maybeAddAwswers(slide) {
        if( this.assignment.quizType !== 'personality' ) {
            return;
        }
        const slides = this.slides;
        const lastIndex = this.slides.length - 1;
        const results = slides[lastIndex].content;
        slide.content[0].bucket = 0;
        for(var i = 1; i < results.length; i++) {
            slide.content.push({text: '', correct: false, bucket: i});
        }
    }
    createSlide(slidePosition?: number) {
        this.createMultipleSlides(slidePosition, 1);
    }    
    createMultipleSlides(slideStartPosition: number, numOfSlides: number) {
        this.saving = true;
        let nextSlide =  slideStartPosition + 1;
        let remaining = numOfSlides;

        let newSlide = this.newSlide();
        let index = newSlide.index;
        let slide = newSlide.slide;
        this.maybeAddAwswers(this.slides[index]);
        this.api.doAction('post', 'slides', {
            action: 'update',
            slide: slide
        })
            .pipe(
                takeWhile(val => this.assignment !== null),
                expand(val => {
                    nextSlide++;
                    remaining--;

                    if(remaining > 0) {
                        newSlide = this.newSlide();
                        index = newSlide.index;
                        slide = newSlide.slide;
                        this.maybeAddAwswers(this.slides[index]);
                    }

                    return remaining == 0 ? EMPTY : this.api.doAction('post', 'slides', { action: 'update', slide: slide });
                }),
                finalize(() => {
                    this.saving = false;
                })
            ).subscribe(
                data => {
                    this.slides[index].id = data.id;
                    this.slides = [].concat(this.slides);
                    this.updateSlideIds();
                    if(nextSlide) {
                        this.moveSlide(index, nextSlide);
                    }
                }
            )
    }
    moveSlide(oldPosition, newPosition) {
        let oldIndex = oldPosition;
        let newIndex = newPosition > oldIndex && newPosition !== 0 ? newPosition - 1 : newPosition;
        if( oldIndex != newIndex ) {
            let slides = this.slides;
            let slide = slides[oldIndex];
            let lastIndex = slides.length - 1;
            if( newIndex === 0 && slides[0].intro ) {
                newIndex = 1;
            }
            if( newIndex === lastIndex && slides[lastIndex].outro ) {
                newIndex = lastIndex - 1;
            }
            slides.splice(oldIndex, 1);
            slides.splice(newIndex, 0, slide);
            this.slides = [].concat(slides);
            this.setSlideOrder();
        }
    }
    saveSlide(slide) {
        if( slide.headers[0] == '' ) {
            slide.headers[0] = slide.title;
        }
        return this.api.doAction('post', 'slides', {
            action: 'update',
            slide: slide
        });
    }
    allSitesHaveCategory() {
        const sites = this.assignment.sites;
        for(var i = 0; i < sites.length; i++) {
            if( sites[i].categories.length === 0 ) {
                return false;
            }
        }
        return true;
    }
    allSitesHavePrimaryCategory() {
        return true;
    }
    getQuizAnswerMessage() {
        let messages = [];
        if( !this.quiz ) {
            return messages;
        }
        const slides = this.slides;
        const type = !this.assignment.quizType ? 'normal' : this.assignment.quizType;
        const message = type == 'personality' ? ' needs personality answers.' : ' needs a correct answer.';
        for(var i = 0; i < slides.length; i++) {
            const slide = slides[i];
            if( !slide.intro && !slide.outro ) {
                const content = slide.content;
                let hasAnswer = false;
                for(var j = 0; j < content.length; j++) {
                    const answer = content[j];
                    hasAnswer = type === 'personality' ? true : false;
                    if( type == 'normal' && answer.correct === true ) {
                        hasAnswer = true;
                        break;
                    } else if( type == 'personality' && (isNaN(answer.bucket) || answer.text == '') ) {
                        hasAnswer = false;
                        break;
                    }
                }
                if( hasAnswer === false ) {
                    messages.push('Slide ' + i + message);
                }
            }
        }
        return messages;
    }
    hasPATaxonomies() {
        const sites = this.assignment.sites;
        const taxes = this.assignment.taxonomies;
        const keys = Object.keys(taxes);
        for(var i = 0; i < sites.length; i++) {
            if( sites[i].blog_id == 14 ) {
                for(var i = 0; i < keys.length; i++) {
                    const key = keys[i];
                    if( 
                        (key == 'decade' && taxes[key].length > 0) || 
                        (key == 'genre' && taxes[key].length > 0) || 
                        (key == 'tv-show' && taxes[key].length > 0) || 
                        (key == 'actor' && taxes[key].length > 0)
                    ) {
                        return true;
                    }
                }
                return false;
            }
        }
        return true;
    }
    maybePublish(schedule?) {
        let error = false;
        let extraMessages = [];
        let data = {
            title: 'Publish Error',
            messages: [],
            allowPublish: false,
            schedule: undefined
        };
        if( this.assignment.articleTitle == '' ) {
            error = true;
            data.messages.push(['Please add an article title.']);
            this.warning = true;
        }
        if( this.assignment.sites.length == 0 ) {
            error = true;
            data.messages.push(['Please select a site.']);
        }
        if( !this.allSitesHaveCategory() ) {
            error = true;
            data.messages.push(['Please add a category for each site.']);
        }
        if( !this.allSitesHavePrimaryCategory() ) {
            error = true;
            data.messages.push(['Please set a primary category for each site.']);
        }
        if( !this.hasPATaxonomies() ) {
            error = true;
            data.messages.push(['Please add taxonomies for PastFactory.']);
        }
        if( this.checkBlacklist() ) {
            data.messages.push(['Warning: There are banned words used in this article.']);
            extraMessages.push(['Warning: There are banned words used in this article.']);
        }
        if( this.checkSiteBlackList(data) ) {
            error = true;
        }
        if ( this.checkAdHeadlineBlackList() ) {
            data.messages.push('Warning: Please fix banned words in Ads tab before publishing');
            extraMessages.push('Warning: Please fix banned words in Ads tab before publishing');
        }
        const quizMessages = this.getQuizAnswerMessage();
        if( quizMessages.length > 0 ) {
            error = true;
            data.messages = data.messages.concat(quizMessages);
        }
        if( !error ) {
            data = {
                title: 'Are you sure?',
                messages: extraMessages,
                allowPublish: true,
                schedule: new Date(this.assignment.date)
            }
        }
        let dialogRef;
        if(!schedule) {
            dialogRef = this.dialog.open(PublishDialog, {
                data: data
            });
        } else {
            dialogRef = this.dialog.open(PublishScheduleDialog, {
                data: data,
                width: '650px'
            });
        }
        dialogRef.afterClosed().subscribe(data => {
            if( data === true ) {
                this.saveSlides(true, true);
            } else if (!!data) { 
                const scheduledTime = data.date;
                scheduledTime.setHours(data.time);
                scheduledTime.setMinutes(data.minutes);
                const schedule = scheduledTime.getTime() <= Date.now() ? undefined : data.date;
                this.saveSlides(true, true, schedule);
            }
        });
    }
    maybeNotify() {
        const prev = this.assignment.previousStatus;
        const next = this.assignment.status;
        if( prev == 'unassigned' && next == 'assigned' ) {
            this.notifyService.statusUpdate('unassigned', 'assigned', this.assignment);
            this.assignment.previousStatus = '';
        }
    }
    getPropValues(props) {
        return (obj) => {
            return props.map(prop => obj[prop]).join(' ');
        }
    }
    checkSlideBlacklist(slide) {
        let blacklisted = false;
        let searchString = '';
        searchString += JSON.stringify(slide.headers) + ' ';
        searchString += this.getPropValues([
            'metaDescription', 
            'metaTitle', 
            'title', 
            'teaser'
        ])(slide) + ' ';

        // add all content (content and summary)
        let contentFields = [ slide.content, slide.summary ];
        contentFields.forEach((field) => {
            for(var i = 0; i < field.length; i++) {
                let result = field[i];
                searchString += this.getPropValues(['text', 'title'])(result) + ' ';
                if( result.hasOwnProperty('image') ) {
                    let image = result.image;
                    searchString += this.getPropValues([
                        'alt', 
                        'caption',
                        'title'
                    ])(image) + ' ';
                }
            }
        });

        // add images
        searchString += slide.images.map(this.getPropValues([
            'alt', 
            'caption', 
            'credit', 
            'description',
            'filename',
            'mime',
            'name',
            'title',
            'url'
        ])).join(' ') + ' ';
        
        searchString += slide.imagesMobile.map(this.getPropValues([
            'alt', 
            'caption', 
            'credit', 
            'description',
            'filename',
            'mime',
            'name',
            'title',
            'url'
        ])).join(' ') + ' ';
        // add quiz feedback
        searchString += slide.feedback.map(this.getPropValues([
            'text'
        ])).join(' ') + ' ';
        const title = this.assignment.articleTitle;
        const metaTitle = this.assignment.metaTitle;
        const metaDesc = this.assignment.metaDescription;
        this.writingTabError = false;
        this.metaTabError = false;
        const blacklist = this.api.getProp('blacklist');
        const len = blacklist.length;
        slide.blacklist = [];
        for(var i = 0; i < len; i++) {
            const term = blacklist[i];
            const regex = new RegExp('\\b' + term + '\\b', 'gi');
            if( searchString.match(regex) ) {
                slide.blacklist.push(term);
                blacklisted = true;
                this.writingTabError = true;
            }
            if( title.match(regex) ) {
                this.writingTabError = true;
                blacklisted = true;
            }
            if( metaTitle.match(regex) ) {
                this.metaTabError = true;
                blacklisted = true;
            }
            if( metaDesc.match(regex) ) {
                this.metaTabError = true;
                blacklisted = true;
            }
        }
        return blacklisted;
    }
    checkSiteBlackList(data) {
        const sites = this.assignment.sites;
        const blacklist = this.api.getProp('blacklist');
        const len = blacklist.length;
        let isBlacklisted = false;
        for(var i = 0; i < sites.length; i++) {
            const site = sites[i];
            let searchString = '';
            if( site.meta.facebookTitle ) {
                searchString += site.meta.facebookTitle + ' ';
            }
            if( site.meta.facebookDescription ) {
                searchString += site.meta.facebookDescription;
            }
            if( !searchString ) {
                continue;
            }
            let hasTerm = false;
            for(var k = 0; k < len; k++) {
                const term = blacklist[k];
                const regex = new RegExp('\\b' + term + '\\b', 'gi');
                if( searchString.match(regex) ) {
                    hasTerm = true;
                    break;
                }
            }
            if( hasTerm ) {
                isBlacklisted = true;
                this.metaTabError = true;
                data.messages.push('Please fix banned words in Facebook meta for ' + site.domain);
            }
        }
        return isBlacklisted;
    }
    setupAds() {
        /* assignment.ads format example:
        * [
        *   {
        *     'description': 'description 1',
        *     'headline': 'headline 1',
        *     'image': {},
        *     'platforms': ['facebook']
        * ]
        */
        this.assignment.ads = this.assignment.ads || [];
    }
    checkAdHeadlineBlackList() {
        const adHeadlines = this.assignment.adHeadlines;
        const blacklist = this.api.getProp('blacklist');
        const len = blacklist.length;
        let isBlacklisted = false;
        this.assignment.ads.forEach(ad => {
            if( !ad.headline ) {
                return;
            }
            let hasTerm = false;
            for(var k = 0; k < len; k++) {
                const term = blacklist[k];
                const regex = new RegExp('\\b' + term + '\\b', 'gi');
                if( ad.headline.match(regex) ) {
                    hasTerm = true;
                    break;
                }
                if( ad.description && ad.description.match(regex) ) {
                    hasTerm = true;
                    break;
                }
            }
            if( hasTerm ) {
                isBlacklisted = true;
                this.adsTabError = true;
            }
        });
        return isBlacklisted;
    }
    checkBlacklist() {
        const slides = this.slides;
        let hasBlacklist = false;
        for(var i = 0; i < slides.length; i++) {
            const isBlacklisted = this.checkSlideBlacklist(slides[i]);
            if( !hasBlacklist ) {
                hasBlacklist = isBlacklisted;
            }
        }
        return hasBlacklist;
    }
    destroyRetry() {
        this.showRetryMessage = false;
        this.retrying = false;
        if( this.retrySubscription ) {
            this.retrySubscription.unsubscribe();
        }
    }
    retryErrorMessage(publish, clearLock) {
        this.retrySubscription = this.retry.subscribe(retry => {
            this.saveSlides(publish, clearLock);
            this.destroyRetry();
        });
        this.showRetryMessage = true;
        setTimeout(() => {
            this.destroyRetry();
        }, 10000);
    }
    saveSlides(publish, clearLock, schedule?) {
        this.warning = false;
        if( this.saving || this.publishing ) return;
        this.stop();
        this.publishing = publish;
        this.saving = true;
        const backupSlides = this.backup ? this.backup.slides : [];
        const currentSlides = this.slides;
        let slidesToSave = [];
        if( !this.objEq(backupSlides, currentSlides) ) {
            for(var i = 0; i < currentSlides.length; i++) {
                const currentSlide = currentSlides[i];
                const backupSlide = backupSlides[i];
                if( !this.objEq(currentSlide, backupSlide) ) {
                    slidesToSave.push(currentSlide);
                }
            }
        }
        let retryErrorNoRecover = false;
        this.retryApiSubscription = this.api.retryError.pipe(
            takeWhile(val => this.assignment !== null)
        ).subscribe((data:any) => {
            if( data.index === 0 ) {
                return;
            }
            if( data.isRetry == true ) {
                // check for correct request
                const requestURL = data.request.url;
                if( requestURL.indexOf('/slides') === -1 && requestURL.indexOf('/assignments') === -1 && requestURL.indexOf('/publish') === -1 ) {
                    return;
                }
                this.retrying = true;
            } else {
                this.retrying = false;
                retryErrorNoRecover = true;
                this.retryErrorMessage(publish, clearLock);
            }
        });
        this.slidesCompleteSubscription = this.slidesComplete.subscribe(() => {
            this.retrying = false;
            if( retryErrorNoRecover === true ) {
                this.saving = false;
                this.publishing = false;
                this.retryApiSubscription.unsubscribe();
                return;
            }
            this.saveAssignment();
            this.setSEOData();
            this.slidesCompleteSubscription.unsubscribe();
        });
        this.assignmentCompleteSubscription = this.assignmentComplete.subscribe(() => {
            this.saving = false;
            this.retrying = false;
            if( retryErrorNoRecover === true ) {
                this.publishing = false;
                this.retryApiSubscription.unsubscribe();
                return;
            }
            this.backup = this.getBackup(this);
            this.maybeNotify();
            if( publish ) {
                this.publish(schedule);
            }
            if( !publish && clearLock ) {
                this.clearLock();
            }
            this.deleteAutosave();
            if( !publish && !clearLock ) {
                this.start();
            }
            this.assignmentCompleteSubscription.unsubscribe();
        });
        this.publishCompleteSubscription = this.publishComplete.subscribe(data => {
            this.retrying = false;
            if( retryErrorNoRecover === false ) {
                this.clearLock();
            }
            this.retryApiSubscription.unsubscribe();
        });
        from(slidesToSave).pipe(
            mergeMap( // performs all requests in parallel
                slide => from(this.saveSlide(slide)).pipe(
                    tap({
                        next: (data:any) => {
                            // compare and update
                            if( JSON.stringify(data.images) !== JSON.stringify(slide.images) ) {
                                // update the slide
                                this.images.images.forEach((image, i) => {
                                    data.images.forEach(data => {
                                        if( image.id === data.alias ) {
                                            const newImage = new SImage(data);
                                            Object.assign(image, newImage);
                                        }
                                    });
                                });
                            }                                
                        },
                        error: (error:any) => {
                            of(error)
                        },
                        complete: () => {
                            console.log('saved');
                        }
                    }),
                    catchError(error => of(error)) // allows error handling per request
                )
            ),
            takeWhile(val => this.assignment !== null),
            finalize(() => {
                this.slidesComplete.emit();
                console.log('Saving slides complete.');
            })
        ).subscribe();
    }
    saveAssignment() {
        if( !this.assignment ) {
            return;
        }
        let slideIds = this.slides.filter(item => item.hasOwnProperty('id')).map(slide => {
            return slide.id;
        });
        this.assignment.slides = slideIds.join(',');
        this.api.doAction('post', 'assignments', {
            action: 'update',
            assignment: this.assignment
        })
            .pipe(
                takeWhile(val => this.assignment !== null),
                finalize(() => {
                    this.assignmentComplete.emit();
                })
            ).subscribe();
    }
    clearLock() {
        this.stop();
        this.locked = true;
        this._locked.emit(this.locked);
        this.assignmentService.deleteLock(this.assignment);
    }
    maybeSetStatus(status) {
        let dialogRef = this.dialog.open(SetStatusDialog, {
            data: { 
                title: 'Ready to Publish',
                status: status,
                targetPublishDate: this.assignment.targetPublishDate
            }
        });
        dialogRef.afterClosed().subscribe(info => {
            if( info ) {
                this.assignment.targetPublishDate = info.targetPublishDate ? this.utils.getFormattedDate(info.targetPublishDate) : '';
                this.targetPublishDateChange.emit();
                this.saving = true;
                this.assignmentCompleteSubscription = this.assignmentComplete.subscribe(() => {
                    this.saving = false;
                    this.assignmentCompleteSubscription.unsubscribe();
                });
                this.setStatus(status);
                this.saveAssignment();
            }
        });
    }
    maybeUpdateStatus() {
        if( this.assignment.status == 'ready_to_delete_an' ) {
            this.setStatus('ready_to_repost');
            return;
        }
        if( this.assignment.status == 'imported' || this.assignment.status == 'future' ) {
            return;
        }
        const user = this.api.getProp('user');
        if( user.id == this.assignment.pageAddWriter && this.assignment.status == 'add_assigned' ) {
            this.setStatus('add_sent_to_editor');
            return;
        }
        if( !this.assignment.published || this.assignment.status == 'revision_requested' ) {
            this.setStatus('sent_to_editor');
        }
    }
    submit() {
        let total = this.slides.length;
        let slideCount = this.assignment.slideCount;
        if( total < slideCount ) {
            let dialogRef = this.dialog.open(SendToEditorDialog, {
                data: { total: total, slideCount: slideCount },
            });
            dialogRef.afterClosed().subscribe(data => {
                if( data !== true ) {
                    this.maybeUpdateStatus();
                    this.saveSlides(false, true);
                    this.addComment(data);
                }
            });
        } else {
            this.maybeUpdateStatus();
            this.saveSlides(false, true);
        }
    }
    addComment(text) {
        if( !text ) {
            return;
        }
        let user = this.api.getProp('user');
        let id = this.assignment.id;
        let date = new Date().toISOString();
        let comment = {
            author: user.id,
            abbreviation: user.abbreviation,
            role: user.role,
            content: text,
            text: text,
            date: date,
            post: id
        };
        this.api.doAction('post', 'comment', {
            action: 'create',
            comment: comment
        })
            .pipe(
                takeWhile(val => this.assignment !== null)
            ).subscribe(
                data => {
                    this.commentAdded.emit(comment);
                    this.notifyService.comment(comment, this.assignment);
                }
            );
    }
    purgeCache() {
        this.api.doAction('post', 'purge', this.assignment).subscribe(
            data => {
                console.log(data);
            }
        );
    }
    updateSlideStatus(status, slideIds) {
        const slides = this.slides;
        for(var i = 0; i < slides.length; i++) {
            const slideId = slides[i].id;
            if( slideId && slideIds.indexOf(slideId) ) {
                slides[i].status = status;
            }
        }
    }
    publish(schedule?) {
        let status = 'publish';
        const currentDate = new Date();
        let publishDate = currentDate;
        if(schedule !== undefined) {
            status = 'future';
            publishDate = schedule;
        }

        const formattedPublishDate = this.utils.getFormattedDate(this.utils.convertDateToUtc(publishDate));
        const formattedCurrentDate = this.utils.getFormattedDate(this.utils.convertDateToUtc(currentDate));

            this.assignment.sites.forEach(site => {
                site.date = formattedPublishDate;
                site.gmt_date = formattedPublishDate;
                
                if(status == 'future') {
                    site.status = status;
                }
            });

        this.assignment.modified = formattedCurrentDate;
        this.assignment.modified_gmt = formattedCurrentDate;
        if(this.assignment.status == 'future' || schedule !== undefined) {
            this.assignment.targetPublishDate = formattedPublishDate;
            this.assignment.publishDate = formattedPublishDate;
            this.assignment.date = formattedPublishDate;
            this.assignment.date_gmt = formattedPublishDate;
        }
        if (this.assignment.status == 'sent_to_editor' || this.assignment.status == 'syn_sent_to_editor' || this.assignment.status == 'ready_to_delete_an' || this.assignment.status == 'ready_to_repost') {
            const user = this.api.getProp("user"),
                notInTeam = new NotInTeam(),
                userNotInTeam = notInTeam.transform([user], this.assignment.team);
            if (userNotInTeam.length > 0 && user.id) {
                const userClass = this.userService.getUser(user.id);
                if (userClass.roles.indexOf('editor') === -1) {
                    userClass.roles.push('editor');
                }
                this.assignment.team.push(userClass);
                this.saveAssignment();
            }
        }
        this.assignment.status = status;

        let copy = {...this.assignment};
        let prevStatus = copy.status;
        this.api.doAction('post', 'publish', this.assignment)
            .pipe(
                takeWhile(val => this.assignment !== null),
                finalize(() => {
                    this.publishing = false;
                    this.publishComplete.emit(true);
                })
            ).subscribe(
                data => {
                    this.publishing = false;
                    this.clearLock();
                    this.assignment.sites = data.sites;
                    this.assignment.published = data.published;
                    this.updateSlideStatus('publish', data.slides);
                    this.purgeCache();
                    this.notifyService.statusUpdate(prevStatus, status, this.assignment);
                    this.assignment.status = status;
                }
            );
    }
    sendPageAdditions() {
        this.sending = true;
        this.assignmentCompleteSubscription = this.assignmentComplete.subscribe(() => {
            this.sending = false;
            this.assignmentCompleteSubscription.unsubscribe();
        });
        this.setStatus('add_assigned');
        this.saveAssignment();
    }
    sendRevisionRequest() {
        this.sending = true;
        this.assignmentCompleteSubscription = this.assignmentComplete.subscribe(() => {
            this.sending = false;
            this.assignmentCompleteSubscription.unsubscribe();
        });
        this.setStatus('revision_requested');
        this.saveAssignment();
    }
    setStatus(status) {
        let copy = { ...this.assignment };
        let prevStatus = copy.status;
        this.assignment.status = status;
        this.notifyService.statusUpdate(prevStatus, status, this.assignment);
        this.statusChange.emit();
    }
    getSlideID(slide, index) {
        if( !slide || !slide.hasOwnProperty('id') ) {
            return '';
        }
        return 'ID: ' + slide.id;
    }
    copy(event, cloneId?, quizToSlideshow?) {
        if( this.locked ) {
            return;
        }

        const ref = this;

        function process(copyAssignment, quizToSlideshow?) {
            const copy = JSON.parse(JSON.stringify(copyAssignment));
            if (quizToSlideshow) {
                copy.childType = '';
                copy.quizType = 'summary';
                copy.quizToSlideshow = true;
                copy.title += ' - Quiz -> Slideshow Copy ' + (ref.clones.length + 1);
            } else {
                copy.title += ' - Copy ' + (ref.clones.length + 1);
            }
            let cloneSlugs = [];
            const clones = ref.clones;
            for(var i = 0; i < clones.length; i++) {
                const sites = clones[i].sites;
                for(var j = 0; j < sites.length; j++) {
                    const slug = sites[j].slug;
                    if( slug ) {
                        cloneSlugs.push(slug);  
                    }
                    const desiredSlug = sites[j].desiredSlug;
                    if( desiredSlug ) {
                        cloneSlugs.push(desiredSlug);  
                    }
                }
            }
            const dialog = ref.dialog.open(CopyDialog, {
                panelClass: 'allow-overflow',
                data: {
                    copy: copy,
                    slugs: cloneSlugs,
                    paTaxonomyOptions: JSON.parse(JSON.stringify(ref.paTaxonomyOptions))
                }
            });
            dialog.afterClosed().subscribe(data => {
                if( data ) {
                    ref.assignment.clones = data.clones;
                    ref.clones.push(data.clone);
                }
            });
        }
        
        if(cloneId) {
            this.api.doAction('post', 'assignments', {
                action: 'get',
                id: cloneId
            }).subscribe(assignment => {
                assignment = new Assignment(assignment);
                assignment.id = ref.assignment.id;
                assignment.cloneParent = cloneId;
                process(assignment);
            });
        } else {
            process(this.assignment, quizToSlideshow);
        }
    }
}
@Component({
    selector: 'copy-dialog',
    template: `
        <h2 mat-dialog-title>Copy Assignment</h2>
        <mat-dialog-content id="copy">
            <label>Title</label>
            <textarea 
                [(ngModel)]="data.copy.title" 
                (input)="clearError()" 
                placeholder="Title">
            </textarea>
            <label>Abbreviation</label>
            <input name="copyDialogAbbr" autocomplete="copyDialogAbbr" id="copyDialogAbbr{{copyDialogAbbr}}" class="abbr" [(ngModel)]="data.copy.abbreviation" (input)="clearError()" placeholder="Abbreviation"/>
            <label>Slug</label>
            <slug-component 
                *ngIf="primary" 
                [(slug)]="primary.slug"
                [allowEmpty]="true"
                [blog_id]="primary.blog_id"
                (propChange)="clearError($event)">
            </slug-component>
            <properties-component 
                [(properties)]="data.copy.sites"
                [canEdit]="true"
                [assignment]="data.copy"
                [(taxOptions)]="data.paTaxonomyOptions">
            </properties-component>
        </mat-dialog-content>
        <mat-dialog-actions>
            <span class="error" [innerHTML]="error"></span>
            <img class="loader" *ngIf="saving" src="/wp-content/themes/swarm/app/assets/images/loading.gif">
            <button class="button" [mat-dialog-close]="false">Cancel</button>
            <button class="button" [disabled]="available === false" (click)="copy()">Copy</button>
        </mat-dialog-actions>`,
})
export class CopyDialog {
    saving = false;
    error = '';
    primary;
    available = false;
    checked = false;
    copyDialogAbbr = this.utils.rand();
    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private api: ApiService, private ref: MatDialogRef<CopyDialog>, private utils: Utils) {
        const primary = data.copy.sites.filter(item => item.primary).shift();
        if( primary ) {
            this.primary = JSON.parse(JSON.stringify(primary));
        } else if (data.copy.sites[0]) {
            // work around for copies of copies
            this.primary = JSON.parse(JSON.stringify(data.copy.sites[0]));
        }
        data.copy.sites = data.copy.sites.map(item => {
            item = new Site({
                abbreviation: item.abbreviation,
                blog_id: item.blog_id,
                domain: item.domain,
                categories: JSON.parse(JSON.stringify(item.categories)),
                primary: item.primary
            });
            const metaKeys = Object.keys(item.meta);
            for(var i = 0; i < metaKeys.length; i++) {
                const key = metaKeys[i];
                if( key.indexOf('hide') !== -1 ) {
                    item.meta[key] = true;
                }
            }
            return item;
        });
    }
    clearError(e = undefined) {
        if( e ) {
            this.available = e.available;
            this.checked = e.checked;
        }
        this.error = '';
        if( this.available === false && this.checked === true ) {
            this.error = 'Please choose a different slug.';
        }
    }
    hasSlug() {
        return this.data.slugs.indexOf(this.primary.slug) !== -1;
    }
    siteHasSlug(sites) {
        const duplicateSlugSites = sites.filter(site => {
            return site.desiredSlug !== '' && site.desiredSlug == this.primary.desiredSlug;
        });
        if(duplicateSlugSites.length > 0) {
            return duplicateSlugSites[0].name;
        }
        return false;
    }
    copy() {
        if( this.available === false ) {
            this.error = 'Please choose a different slug.';
            return;
        }
        if( this.hasSlug() ) {
            this.error = 'Please choose a different slug.';
            return;
        }
        const errorSite = this.siteHasSlug(this.data.copy.sites);
        if( errorSite !== false ) {
            this.error = `Please choose a different slug for ${errorSite}.`;
            return;
        }
        this.saving = true;
        this.data.copy.sites = this.data.copy.sites.map(item => {
            if(item.desiredSlug === '') {
                item.desiredSlug = this.primary.slug;
            }
            return item;
        });
        this.api.doAction('post', 'clone', {
            action: 'copy',
            data: this.data.copy
        }).pipe(
            finalize(() => {
                this.saving = false;
            })
        ).subscribe(
            data => {
                this.ref.close(data);
            },
            err => {
                console.log(err);
                this.error = err.hasOwnProperty('error') ? err.error.message : err.message;
                throw err;
            }
        );
    }
}
@Component({
    selector: 'takeover-dialog',
    template: `
        <h2 mat-dialog-title>Assignment Locked</h2>
        <mat-dialog-content>{{data.user}} is currently editing this assignment. Would you like to take over?</mat-dialog-content>
        <mat-dialog-actions>
            <button class="button" [mat-dialog-close]="true">Cancel</button>
            <button class="button" mat-dialog-close>Yes</button>
        </mat-dialog-actions>`,
})
export class TakeoverDialog {
    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
@Component({
    selector: 'autosave-dialog',
    template: `
        <h2 mat-dialog-title>Restore Assignment</h2>
        <mat-dialog-content>There is an autosave of this assignment from {{data.date | date: 'medium'}}. Would you like to restore?</mat-dialog-content>
        <mat-dialog-actions>
            <button class="button" [mat-dialog-close]="true">Cancel</button>
            <button class="button" mat-dialog-close>Yes</button>
        </mat-dialog-actions>`,
})
export class AutosaveDialog {
    constructor(@Inject(MAT_DIALOG_DATA) public data: any) {}
}
@Component({
    selector: 'send-to-editor-dialog',
    template: `
        <h2 mat-dialog-title>Send to Editor</h2>
        <mat-dialog-content fxLayout="column" fxLayoutGap="10px">
            <div *ngIf="!confirmed">Are you sure you want to send {{data.total}} of {{data.slideCount}} slides?</div>
            <mat-form-field *ngIf="confirmed" id="send-to-editor">
                <textarea matInput [(ngModel)]="notes" placeholder="Add a note" (keyup.enter)="send()"></textarea>
            </mat-form-field>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button class="button" [mat-dialog-close]="true">Cancel</button>
            <button class="button" *ngIf="!confirmed" (click)="confirm()">Yes</button>
            <button class="button" *ngIf="confirmed" [mat-dialog-close]="notes">Send</button>
        </mat-dialog-actions>`,
})
export class SendToEditorDialog {
    confirmed = false;
    notes = '';
    confirm() {
        this.confirmed = true;
    }
    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private ref: MatDialogRef<SendToEditorDialog>) { }
    send() {
        this.ref.close(this.notes);
    }
}
@Component({
    selector: 'set-status-dialog',
    template: `
        <h2 mat-dialog-title>{{data.title}}</h2>
        <mat-dialog-content fxLayout="column" fxLayoutGap="10px">
            <mat-form-field *ngIf="showDate">
                <input matInput name="setStatusDialogPublishDate" autocomplete="setStatusDialogPublishDate" id="setStatusDialogPublishDate{{setStatusDialogPublishDate}}" [matDatepicker]="picker" placeholder="Target Publish Date" [(ngModel)]="info.targetPublishDate" [min]="minDate">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button class="button" [mat-dialog-close]="false">Cancel</button>
            <button class="button" [mat-dialog-close]="info">Update</button>
        </mat-dialog-actions>`,
})
export class SetStatusDialog {
    info = {
        targetPublishDate: new Date()
    };
    minDate = new Date();
    showDate = false;
    setStatusDialogPublishDate = this.utils.rand();
    constructor(@Inject(MAT_DIALOG_DATA) public data: any, private utils: Utils) {
        if( data.status == 'publish_ready' ) {
            this.showDate = true;
            this.info.targetPublishDate = data.targetPublishDate ? new Date(data.targetPublishDate) : this.info.targetPublishDate;
        }
    }
}
@Component({
    selector: 'delete-dialog',
    template: `
        <h2 mat-dialog-title>{{data.title}}</h2>
        <mat-dialog-content>
            <p *ngFor="let message of data.messages; trackBy: utils.trackByIndex">{{message}}</p>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button class="button" [mat-dialog-close]="false">Cancel</button>
            <button class="button" [mat-dialog-close]="true">Delete</button>
        </mat-dialog-actions>`,
})
export class DeleteDialog {
    constructor( @Inject(MAT_DIALOG_DATA) public data: any, public utils: Utils) { }
}
@Component({
    selector: 'publish-dialog',
    template: `
        <h2 mat-dialog-title>{{data.title}}</h2>
        <mat-dialog-content>
            <p *ngFor="let message of data.messages; trackBy: utils.trackByIndex">{{message}}</p>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button class="button" [mat-dialog-close]="false">Cancel</button>
            <button class="button" *ngIf="data.allowPublish === true" [mat-dialog-close]="true">Publish</button>
        </mat-dialog-actions>`,
})
export class PublishDialog {
    constructor( @Inject(MAT_DIALOG_DATA) public data: any, public utils: Utils) { }
}
@Component({
    selector: 'publish-schedule-dialog',
    template: `
        <h2 mat-dialog-title>{{data.title}}</h2>
        <mat-dialog-content>
            <p *ngFor="let message of data.messages; trackBy: utils.trackByIndex">{{message}}</p>
        </mat-dialog-content>
        <mat-card *ngIf="data.allowPublish === true" class="inline-calendar-card">
            <mat-calendar [minDate]="minDate" [selected]="selectedDate" (selectedChange)="updateOnDateChange($event)"></mat-calendar>
        </mat-card>
        <mat-form-field *ngIf="data.allowPublish === true" class="example-form-field">
            <mat-label>Hour (24 Hour Time Format)</mat-label>
            <input matInput min="0" max="23" type="number" [ngModel]="selectedTime" (ngModelChange)="updateOnTimeChange($event)" onKeyDown="return false" />
        </mat-form-field>
        <mat-form-field *ngIf="data.allowPublish === true" class="example-form-field">
            <mat-label>Minutes</mat-label>
            <input matInput min="0" max="59" type="number" [(ngModel)]="selectedMinutes" (ngModelChange)="updateOnMinutesChange($event)" onKeyDown="return false" />
        </mat-form-field>
        <div *ngIf="data.allowPublish === true && beforeNow === false">Will publish on: <time>{{formatDate()}}</time></div>
        <div *ngIf="data.allowPublish === true && beforeNow === true">Will be published immediately</div>
        <mat-dialog-actions>
            <button class="button" [mat-dialog-close]="false">Cancel</button>
            <button class="button" *ngIf="data.allowPublish === true" [mat-dialog-close]="dataOut" [disabled]="!selectedDate || dataOut.date == undefined || dataOut.time == undefined || dataOut.minutes == undefined">Publish</button>
        </mat-dialog-actions>`,
})
export class PublishScheduleDialog {
    selectedDate: Date;
    selectedTime;
    selectedMinutes;
    selectedTimeControl;

    dataOut = {date: undefined, time: undefined, minutes: undefined};

    minDate;
    maxDate;
    beforeNow = false;
    constructor( @Inject(MAT_DIALOG_DATA) public data: any, public utils: Utils) {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const tomorrow = new Date(today);
        tomorrow.setDate(tomorrow.getDate() + 1);

        this.selectedDate = tomorrow;
        this.minDate = today;

        this.selectedTime = this.selectedDate.getHours();
        this.selectedMinutes = this.selectedDate.getMinutes();
    }

    updateOnDateChange(value) {
        this.selectedDate = value;
        this.updateOnDateTimeChange();
    }

    updateOnTimeChange(value) {
        this.selectedTime = value;
        this.updateOnDateTimeChange();
    }
    updateOnMinutesChange(value) {
        this.selectedMinutes = value;
        this.updateOnDateTimeChange();
    }

    updateOnDateTimeChange() {
        this.dataOut.date = this.selectedDate;
        this.dataOut.time = this.selectedTime;
        this.dataOut.minutes = this.selectedMinutes;

        const time = new Date(this.selectedDate);
        time.setHours(this.selectedTime);
        time.setMinutes(this.selectedMinutes);

        this.beforeNow = time.getTime() <= Date.now();
    }

    formatDate() {
        this.selectedDate.setHours(this.selectedTime);
        this.selectedDate.setMinutes(this.selectedMinutes);
        const d = this.selectedDate;
        const months = [
            'January',
            'February',
            'March',
            'April',
            'May',
            'June',
            'July',
            'August',
            'September',
            'October',
            'November',
            'December'
        ];

        const days = [
            'Sun',
            'Mon',
            'Tue',
            'Wed',
            'Thu',
            'Fri',
            'Sat'
        ];

        const dayOfWeek = days[d.getDay()];
        const month = months[d.getMonth()];
        const day = d.getDate();
        const year = d.getFullYear();

        let minutes = ('0' + d.getMinutes()).slice(-2);
        let hour = ('0' + (d.getHours() % 12)).slice(-2);
        hour = hour == '00' ? '12' : hour;
        
        const meridiem = d.getHours() > 11 ? 'PM' : 'AM';
        const timezone = new Date().toLocaleTimeString('en-us', {timeZoneName:'short'}).split(' ')[2];
        
        const date = `${dayOfWeek}, ${month} ${day}, ${year}`;
        const time = `${hour}:${minutes}${meridiem} ${timezone}`;

        return `${date} - ${time}`;
    }
}
@Component({
    selector: 'cannot-view-dialog',
    template: `
        <h2 mat-dialog-title>Access Denied</h2>
        <mat-dialog-content>
            <p>Sorry! You are not allowed to view this assignment. <ng-container *ngIf="data">Please contact {{data.name}} for access.</ng-container></p>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button class="button" mat-dialog-close>My Queue</button>
        </mat-dialog-actions>`,
})
export class CannotViewDialog {
    constructor(@Inject(MAT_DIALOG_DATA) public data: any) { }
}
@Component({
    selector: 'featured-image-dialog',
    template: `
        <h2 mat-dialog-title>Image Too Small</h2>
        <mat-dialog-content>
            <p>Mobile only images cannot be used as a featured image.</p>
        </mat-dialog-content>
        <mat-dialog-actions>
            <button class="button" mat-dialog-close>OK</button>
        </mat-dialog-actions>`,
})
export class FeaturedImageDialog {
    constructor() { }
}